<template>
  <div
    :class="{
      'social-post-status-pill': true,
      'social-post-status-pill--green': props.color === 'green',
      'social-post-status-pill--red': props.color === 'red',
      'social-post-status-pill--gray': props.color === 'gray',
      'social-post-status-pill--white': props.color === 'white',
    }"
  >
    <IconEmbedded v-if="props.isWithCheckIcon" name="check_4-5" color="rgba(84, 158, 63, 1)" :size="12" />
    <span>{{ props.text }}</span>
  </div>
</template>

<script setup lang="ts">
import IconEmbedded from "@components/ui/IconEmbedded.vue";

const props = withDefaults(
  defineProps<{
    color?: "white" | "green" | "red" | "gray";
    isWithCheckIcon?: boolean;
    text: string;
  }>(),
  {
    color: "white",
    isWithCheckIcon: false,
    text: "Status",
  }
);
</script>

<style scoped lang="scss">
@import "@/scss/variables.scss";

.social-post-status-pill {
  @include standardFont;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 11px 1px;
  border: 1px solid rgba(208, 208, 208, 1);
  border-radius: 999px;
  background: white;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.16);
  font-size: 12px;
  font-weight: 500;
  line-height: 1.2;
  white-space: nowrap;

  &--green {
    border-color: rgba(193, 219, 184, 1);
    background: rgba(208, 229, 201, 1);
    color: rgba(44, 117, 23, 1);
  }

  &--red {
    border-color: rgb(220, 188, 188);
    background: rgb(236, 208, 208);
    color: rgb(117, 23, 23);
  }

  &--gray {
    border-color: rgb(224, 224, 224);
    background: rgb(241, 241, 241);
    color: rgb(113, 113, 113);
  }

  &--white {
    border-color: rgba(208, 208, 208, 1);
    background: white;
    color: rgba(73, 73, 73, 1);
  }
}
</style>
